import script from "./SelectPrintNew.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectPrintNew.vue?vue&type=script&lang=ts&setup=true"

import "./SelectPrintNew.vue?vue&type=style&index=0&id=d22ce2ec&lang=scss&scoped=true"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d22ce2ec"]])

export default __exports__